import type { HttpClient } from '@/lib/http/client.js'
import type {
  ReviewPromptReset,
  Shop,
  ShopCredentialState,
  ShopPage,
  ShopSearch,
} from '@/types/shop/shop.type.js'

/** `admin/shops`, verified against `shop-admin.controller.ts`. Read-only but for one action. */
export interface ShopService {
  search: (query: ShopSearch) => Promise<ShopPage>
  get: (id: string) => Promise<Shop>
  /** High risk: `shop-credential-view`. Called only when an operator asks, never on load. */
  credentialState: (id: string) => Promise<ShopCredentialState>
  /**
   * The ONE write this surface has, gated on `shop-edit`.
   *
   * Clears `reviewed_at` AND the card dismissal — the app hides the rating card on either
   * one independently, so clearing a single field leaves it hidden for every merchant who
   * dismissed it. Verified against `shop-admin.controller.ts`.
   */
  resetReviewPrompt: (id: string) => Promise<ReviewPromptReset>
}

export function createShopService(http: HttpClient): ShopService {
  return {
    search: (query) => http.get<ShopPage>('admin/shops', { query: { ...query } }),
    get: (id) => http.get<Shop>(`admin/shops/${encodeURIComponent(id)}`),
    credentialState: (id) =>
      http.get<ShopCredentialState>(`admin/shops/${encodeURIComponent(id)}/credential-state`),
    resetReviewPrompt: (id) =>
      http.post<ReviewPromptReset>(`admin/shops/${encodeURIComponent(id)}/review-prompt/reset`, {}),
  }
}
